import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=5b89c2e9&scoped=true&"
import script from "./Diff.vue?vue&type=script&lang=js&"
export * from "./Diff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89c2e9",
  null
  
)

export default component.exports